'use strict';

var keyboardAccessibility = require('./keyboardAccessibility');
var $navBar = $('.navbar-nav');
var $mainMenu = $('.main-menu');
var $pageHeader = $('header');
var $headerBanner = $('.header-banner');
const $navbarToggler = $('.navbar-toggler');

const clearSelection = function (element) {
    const $ele = $(element);
    const $li = $ele.closest('li');
    const $dropdown = $ele.closest('.dropdown.show');
    const $menu = $dropdown.children('.dropdown-menu');

    $dropdown.children('.dropdown-menu').children('.top-category').detach();
    $dropdown.children('.nav-link').attr('aria-expanded', 'false');
    $menu.attr('aria-hidden', 'true');
    $dropdown.removeClass('show');
    $('div.menu-group > ul.nav.navbar-nav > li.nav-item > a').attr('aria-hidden', 'false');

    setTimeout(function () {
        $li.detach();
    }, 450);
};

var quickLinksSlider = function ($quickLinks) {
    if ($quickLinks.is(':visible') && $quickLinks.hasClass('slick-slider')) {
        $quickLinks.slick('unslick');
    }

    $quickLinks.slick({
        variableWidth: true,
        arrows: true,
        infinite: true
    });
    $quickLinks.closest('.dropdown-menu').css('padding-bottom', $quickLinks.outerHeight());
};

var renderMobileCategories = function ($parent) {
    var allCategories;
    if ($parent && !$parent.hasClass('sorted-category')) {
        $parent.addClass('sorted-category');
        allCategories = $parent.find('> li.dropdown-item:not(.dropdown-item-off)').first();
        var allCategoriesHtml = allCategories.find('> .dropdown-link').clone();

        // Process dropdown-item-off sections with their own index
        $parent.find('> li.dropdown-item-off').each(function () {
            var $dropDown = $(this);
            $dropDown.removeClass('dropdown').find('.dropdown-link').removeClass('dropdown-toggle').removeAttr('data-toggle');
            $dropDown.append($dropDown.find('.dropdown-menu .dropdown-link').clone());
            $dropDown.find('.dropdown-menu').remove();
            if ($dropDown.find('.dropdown-link:not(.dropdown-sub-title):not(.see-all-category)').length > $parent.data('viewcount')) {
                var viewMoreLink = $dropDown.find('.dropdown-sub-title').clone();
                viewMoreLink.html($parent.data('viewmore')).removeClass('dropdown-sub-title dropdown-sub-title-anchor text-uppercase').addClass('see-all-category');
                $dropDown.append(viewMoreLink);
            }
            var removeLinks = $dropDown.find('.dropdown-link:not(.dropdown-sub-title):not(.see-all-category)').splice($parent.data('viewcount'), $dropDown.find('.dropdown-link').length);
            $.each(removeLinks, function () {
                $(this).remove();
            });
        });

        // Process remaining items (non dropdown-item-off)
        $parent.find('> li:not(.cat-banner):not(.dropdown-item-off)').each(function () {
            var $dropDown = $(this);
            if ($dropDown.is(allCategories)) {
                allCategories.addClass('dropdown-item-off dropdown-item-all-cat').removeClass('dropdown-item dropdown');
                $dropDown.html('<span class="dropdown-link dropdown-sub-title text-uppercase view-all-categories">' + $parent.data('thecategories') + '</span>');
                $dropDown.append(allCategoriesHtml);
            } else if (!$dropDown.is(allCategories)) {
                allCategories.append($dropDown.find('> .dropdown-link').clone());
                $dropDown.remove();
            }
        });
        allCategories.find('.dropdown-link').removeClass('dropdown-toggle').removeAttr('data-toggle');

        if ($parent.find('.dropdown-item-all-cat').length > 0) {
            var seeAllLink = $parent.prev('.dropdown-link').clone();
            seeAllLink.html($parent.data('seewhole')).removeClass('dropdown-toggle').removeAttr('data-toggle').addClass('see-all-category');
            $parent.find('.dropdown-item-all-cat').append(seeAllLink);
        }
    }
};

var adjustRefinementsBarOnScroll = function () {
    var scrollPos = $(window).scrollTop();
    var headerBannerStatus = window.sessionStorage.getItem('hide_header_banner');

    if ((scrollPos === 0 && !headerBannerStatus) || headerBannerStatus < 0) {
        const refinementsBarHide = new Event('refinements_bar_hide', { bubbles: true });
        document.dispatchEvent(refinementsBarHide);
    } else if (scrollPos > $headerBanner.height()) {
        const refinementsBarDisplay = new Event('refinements_bar_display', { bubbles: true });
        document.dispatchEvent(refinementsBarDisplay);
    }
};

const closeMainMenu = function (options) {
    const config = options || {};

    $mainMenu.removeClass('in');
    $mainMenu.attr('aria-hidden', 'true');
    $mainMenu.siblings().attr('aria-hidden', 'false');
    $pageHeader.siblings().attr('aria-hidden', 'false');
    $navbarToggler.attr('aria-expanded', 'false');
    $('.modal-background').hide();
    $('body').removeClass('menu-open');

    if (config.clearNavigationState) {
        $navBar.find('.top-category').detach();
        $navBar.find('.nav-menu').detach();
        $navBar.find('.show').removeClass('show');
    }

    if (config.adjustRefinements) {
        adjustRefinementsBarOnScroll();
    }

    if (config.restoreFocus) {
        $navbarToggler.focus();
    }

    if (config.focusFirstItem) {
        let $first = $mainMenu.find('.close-button-main button').filter(':visible').first();
        if (!$first.length) {
            $first = getFocusableInsideMenu().first();
        }
        $first.focus();
    }
};

const openMainMenu = function (options) {
    const config = options || {};

    $mainMenu.addClass('in');
    $mainMenu.attr('aria-hidden', 'false');
    $mainMenu.siblings().attr('aria-hidden', 'true');
    $pageHeader.siblings().attr('aria-hidden', 'true');
    $navbarToggler.attr('aria-expanded', 'true');
    $('.modal-background').show();
    $('body').addClass('menu-open');

    if (config.focusFirstItem) {
        $mainMenu.find('.close-button button, .nav.navbar-nav .nav-link:visible').filter(':visible').first().focus();
    }
};

const getFocusableInsideMenu = function () {
    const $deepestOpenMenu = $mainMenu.find('.dropdown.show > .dropdown-menu').last();
    const $scope = $deepestOpenMenu.length ? $deepestOpenMenu : $mainMenu;
    return $scope
        .find('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"]), input, select, textarea')
        .filter(':visible');
};

const headerMenuEvents = function () {
    const headerBannerStatus = window.sessionStorage.getItem('hide_header_banner');
    $('.header-banner .close').on('click', function () {
        $headerBanner.addClass('is-hidden');
        window.sessionStorage.setItem('hide_header_banner', '1');
    });

    if (!headerBannerStatus || headerBannerStatus < 0) {
        $headerBanner.removeClass('is-hidden');
    }

    const pageProductDetails = document.querySelector('.product-detail');
    if (window.visualViewport.width <= 768 && pageProductDetails) {
        $headerBanner.addClass('is-hidden');
    }

    $(window).on('scroll', function () {
        if ($('#sg-navbar-collapse').attr('aria-hidden') == 'true' || typeof $('#sg-navbar-collapse').attr('aria-hidden') === 'undefined') {
            adjustRefinementsBarOnScroll();
        }
    });

    $mainMenu.on('keydown', function (e) {
        if (!$mainMenu.hasClass('in')) return;
        if (e.key === 'Tab') {
            const $focusables = getFocusableInsideMenu();
            if (!$focusables.length) return;
            const first = $focusables.first()[0];
            const last = $focusables.last()[0];
            const active = document.activeElement;
            if (e.shiftKey && active === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && active === last) {
                e.preventDefault();
                first.focus();
            }
        }
    });

    $mainMenu.on('keydown', function (e) {
        if (e.key !== 'Escape' || !$mainMenu.hasClass('in')) return;
        const $openSub = $mainMenu.find('.nav-item.dropdown.show, .dropdown-item.dropdown.show').last();
        if ($openSub.length) {
            // Sous-menu ouvert : on revient au niveau parent
            e.preventDefault();
            const $back = $openSub.find('> .dropdown-menu .back').first();
            if ($back.length) {
                $back.trigger('click');
                $openSub.children('.dropdown-toggle').focus();
            }
        } else {
            // Aucun sous-menu : on ferme le menu
            e.preventDefault();
            closeMainMenu({ restoreFocus: true });
        }
    });

    $mainMenu.on('keydown', '.dropdown-toggle', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $(this).trigger('click');
            // déplace le focus dans le sous-menu après l'animation
            const $self = $(this);
            setTimeout(function () {
                $self.parent()
                    .find('> .dropdown-menu a, > .dropdown-menu button')
                    .filter(':visible')
                    .first()
                    .focus();
            }, 50);
        }
    });

    $mainMenu.on('keydown', '.back', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $(this).trigger('click');
        }
    });

    $mainMenu.on('keydown', '.nav-link, .dropdown-link', function (e) {
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        e.preventDefault();
        const $items = $(this).closest('ul')
            .find('> li > a, > li > button, > li > .dropdown-link, > li > .dropdown-toggle')
            .filter(':visible');
        const idx = $items.index(this);
        const nextIdx = e.key === 'ArrowDown'
            ? (idx + 1) % $items.length
            : (idx - 1 + $items.length) % $items.length;
        $items.eq(nextIdx).focus();
    });

    $('.dropdown:not(.disabled):not(.country-dropdown) [data-toggle="dropdown"]')
        .on('click', function (e) {
            if ($(this).hasClass('desktop-toggle')) {
                return true;
            }
            if ($(this).parent().hasClass('show')) {
                return false;
            }
            e.preventDefault();
            e.stopPropagation();
            $('.modal-background').show();
            // copy parent element into current UL
            const link = $(this).clone().removeClass('dropdown-toggle')
                .removeAttr('data-toggle')
                .removeAttr('aria-expanded')
                .attr('aria-haspopup', 'false');
            let closeMenu = $('<li class="nav-menu"></li>');
            const $closeMenuClone = $('.close-menu').first().clone();

            $closeMenuClone.find('.navbar-mobile-logo').remove();
            const $rightGroup = $closeMenuClone.find('.close-button').parent();

            $('<button type="button" class="back" aria-label="Back"></button>').insertBefore($rightGroup);
            $(link).insertBefore($rightGroup);

            closeMenu.append($closeMenuClone);

            $(this).parent().children('.dropdown-menu')
                .prepend(closeMenu)
                .attr('aria-hidden', 'false');
            // copy navigation menu into view
            $(this).parent().addClass('show');
            $(this).attr('aria-expanded', 'true');
            $('div.menu-group > ul.nav.navbar-nav > li.nav-item > a').attr('aria-hidden', 'true');
            if ($(this).parent().parent().hasClass('cat-level-2') && $(this).parent().parent().find('.dropdown-item-slick').length && !$(this).parent().children('.dropdown-menu').find('.quickaccess-slick').length) {
                $(this).parent().children('.dropdown-menu').append('<li class="quickaccess-slider">' + $(this).parent().parent().find('.dropdown-item-slick')
                    .html() + '</li>');
                quickLinksSlider($(this).parent().children('.dropdown-menu').find('.quickaccess-slick'));
            }
            return true;
        });

    $('.navbar').on('click', '.close-button-main', function (e) {
        e.preventDefault();
        closeMainMenu({
            restoreFocus: true
        });
    });
    $('.close-button.close-button-main').on('click', function (e) {
        e.preventDefault();
        closeMainMenu({
            adjustRefinements: true,
            restoreFocus: true
        });
    });

    $('.navbar').on('click', '.search-btn', function (e) {
        e.preventDefault();
        closeMainMenu({ clearNavigationState: true });
        const $searchInput = $('.form-control.search-field.general-search-input')
            .filter(':visible')
            .first();
        if ($searchInput.length) {
            $searchInput.focus();
            $searchInput[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    });

    $navBar.on('click', '.back', function (e) {
        e.preventDefault();
        clearSelection(this);
    });

    $('.navbar').on('click', '.back', function (e) {
        e.preventDefault();
        const $parentDropdown = $(this).closest('.dropdown.show');
        const $toggle = $parentDropdown.children('.dropdown-toggle');
        clearSelection(this);

        if ($toggle.length) {
            $toggle.focus();
        }
    });

    $navBar.on('click', '.close-button', function (e) {
        e.preventDefault();
        closeMainMenu({
            clearNavigationState: true,
            restoreFocus: true
        });
    });

    keyboardAccessibility('.navbar-header .user',
        {
            40: function ($popover) { // down
                if ($popover.children('a').first().is(':focus')) {
                    $popover.next().children().first().focus();
                } else {
                    $popover.children('a').first().focus();
                }
            },
            38: function ($popover) { // up
                if ($popover.children('a').first().is(':focus')) {
                    $(this).focus();
                    $popover.removeClass('show');
                } else {
                    $popover.children('a').first().focus();
                }
            },
            27: function () { // escape
                $('.navbar-header .user .popover').removeClass('show');
                $('.user').attr('aria-expanded', 'false');
            },
            9: function () { // tab
                $('.navbar-header .user .popover').removeClass('show');
                $('.user').attr('aria-expanded', 'false');
            }
        },
        function () {
            var $popover = $('.user .popover li.nav-item');
            return $popover;
        });

    $('.navbar-header .user').on('mouseenter focusin', function () {
        if ($('.navbar-header .user .popover').length > 0) {
            $('.navbar-header .user .popover').addClass('show');
            $('.user').attr('aria-expanded', 'true');
        }
    });

    $('.navbar-header .user').on('mouseleave', function () {
        $('.navbar-header .user .popover').removeClass('show');
        $('.user').attr('aria-expanded', 'false');
    });
    $('body').on('click', '#myaccount', function (e) {
        e.preventDefault();
    });

    $('.cat-level-3').each(function () {
        var $parent = $(this);
        renderMobileCategories($parent);
    });
};

var loadSubCategories = function () {
    // Bind burger toggle immediately so it works before AJAX completes (Android WebView compat)
    $navbarToggler.on('click', function (e) {
        e.preventDefault();
        if ($mainMenu.hasClass('in')) {
            closeMainMenu({
                restoreFocus: true
            });
            return;
        }
        openMainMenu({
            focusFirstItem: true
        });
    });

    if ($('.main-menu').length > 0) {
        const encodedActionUrl = $('.main-menu').data('action');
        const actionUrl = atob(encodedActionUrl);
        $.ajax({
            url: actionUrl,
            type: 'GET',
            dataType: 'HTML',
            success: function (data) {
                $('.main-menu').html(data);
                headerMenuEvents();
            },
            error: function () {
                headerMenuEvents();
            }
        });
    }
};

$(document).on('click', '.modal-background', function () {
    if ($('.main-menu').hasClass('in')) {
        $('.navbar-toggler').trigger('click');
    }
});

module.exports = loadSubCategories;
